export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/837e258702481769ad64684ae735d0c9.svg";